import { useEffect, useState } from 'react'

export const useBodyOverflow = () => {
  const [overflow, setOverflow] = useState('')

  useEffect(() => {
    const bodyStyle = window.getComputedStyle(document.body)
    setOverflow(bodyStyle.overflow)

    const observer = new MutationObserver(() => {
      const newValue = window.getComputedStyle(document.body).overflow
      setOverflow(newValue)
    })

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
    })

    return () => observer.disconnect()
  }, [])

  return overflow
}
